var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49875 16.9969H18.5427C18.9441 16.9969 19.3397 16.9002 19.6959 16.715C20.052 16.5298 20.3584 16.2615 20.5889 15.9329C20.8195 15.6043 20.9675 15.2249 21.0204 14.827C21.0734 14.4291 21.0297 14.0242 20.893 13.6467L18.5169 7.07727C18.1111 5.61733 17.2382 4.3305 16.0318 3.4136C14.8254 2.49669 13.3519 2.00018 11.8366 2C10.2592 1.99998 8.72895 2.53788 7.49851 3.5249C6.26807 4.51191 5.41101 5.88903 5.06884 7.42887L3.11092 13.7609C2.99564 14.1347 2.96972 14.5304 3.03526 14.9161C3.10079 15.3018 3.25593 15.6667 3.48821 15.9815C3.72049 16.2962 4.02342 16.5521 4.37262 16.7285C4.72182 16.9048 5.10754 16.9968 5.49875 16.9969Z",
    fill: "#CAC4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02489 18.6632C8.21611 19.6049 8.72702 20.4515 9.47104 21.0597C10.2151 21.6678 11.1464 22 12.1074 22C13.0683 22 13.9997 21.6678 14.7437 21.0597C15.4877 20.4515 15.9986 19.6049 16.1899 18.6632H8.02489Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject2);
export default __webpack_public_path__ + "static/media/project2.c81f41f4.svg";
export { ForwardRef as ReactComponent };